/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Learn_Attemptscount1Inputs */

const zh_learn_attemptscount1 = /** @type {(inputs: Learn_Attemptscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作答记录 (${i?.count})`)
};

const en_learn_attemptscount1 = /** @type {(inputs: Learn_Attemptscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attempts (${i?.count})`)
};

const es_learn_attemptscount1 = /** @type {(inputs: Learn_Attemptscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Intentos (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Attempts ({count})" |
*
* @param {Learn_Attemptscount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_attemptscount1 = /** @type {((inputs: Learn_Attemptscount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Attemptscount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_attemptscount1(inputs)
	if (locale === "en") return en_learn_attemptscount1(inputs)
	return es_learn_attemptscount1(inputs)
});
export { learn_attemptscount1 as "learn_attemptsCount" }